import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Search } from 'components/common';

const FollowUsersSearch = () => {
  const { messages } = useReduxState();

  return (
    <div className="search-form">
      <Search
        placeholder={messages.usersSearchUsers}
        withUrl={true}
        size="header"
      />

      <style jsx>{`
        @media (min-width: ${breakpoints.small}px) {
          .search-form :global(input) {
            min-width: 240px;
          }
        }
      `}</style>
    </div>
  );
};

export default FollowUsersSearch;
